import { App } from 'vue'
// https://docs.sentry.io/platforms/javascript/guides/vue/#vue-3
import { cookies } from '@/utils/cookie'
import router from '@/router'

export const sentry = {
  install: (app: App) => {
    const isDEV = process.env.VUE_APP_ENV == 'development'
    if (!isDEV) {
      import('@sentry/vue').then(Sentry => {
        import('@sentry/tracing').then(({ Integrations }) => {
          Sentry.init({
            app,
            dsn: 'https://8e6fc77d975946e7bfe3f12ce3d9b3a0@trap.cekid.com/143',
            environment: 'production',
            integrations: [
              new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router)
              })
            ],
            release: '' // --sentry release--
          })
          Sentry.setUser({
            uid: cookies.get('uid')
          })
        })
      })
    }
  }
}
